import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { createPinia } from 'pinia';

import { __ } from './mixins/__';
import { routes } from './routes';

import App from './App.vue';
import '/node_modules/@teamfurther/cinderblock/dist/cinderblock.css';

const app = createApp(App);
const pinia = createPinia();
const router = createRouter({
    history: createWebHistory(),
    routes
});

app.config.globalProperties.app = {
    name: import.meta.env.VITE_APP_NAME,
}

app.use(pinia);
app.use(router);

app.use(__);
app.provide('__', app.config.globalProperties.__);

app.mount('#app');